module.exports = __webpack_public_path__ + "img/app_chineserd.6cdf92e9.png";